import { HOST } from '@/api/index.js'
import { OPTIONS } from '@/api/landing/index.js'

export const sendQuestion = async (email, question) => {
	const url = `${HOST}/contact/send_question`

	const response = await fetch(url, {
		...OPTIONS,
		method: 'POST',
		body: JSON.stringify({
			email: email,
			question: question
		})
	})

	return await response.json()
}
